<template>
    <div>
        <template v-if="title">
            <div class="mb-2 text-[11px] font-semibold tracking-wide text-gray-500 uppercase">
                {{ title }}
            </div>
            <hr class="mt-0 mb-2" />
        </template>
        <div v-if="contacts?.length">
            <div v-for="contact in contacts" :key="contact.id" class="mb-2">
                <div class="flex items-center gap-2">
                    <span>{{ contact.name }}</span>
                    <a
                        v-if="showPhone(contact)"
                        :href="'tel:' + contact.phone"
                        class="text-primary"
                        :aria-label="`Call ${contact.name || contact.phone}`"
                        @click.stop=""
                    >
                        <icon name="cil-phone" />
                    </a>
                    <a
                        v-if="showEmail(contact)"
                        :href="'mailto:' + contact.email"
                        class="text-primary"
                        :aria-label="`Email ${contact.name || contact.email}`"
                        @click.stop=""
                    >
                        <icon name="cil-envelope-closed" />
                    </a>
                </div>
                <div v-if="contact.role" class="text-sm text-gray-500">{{ contact.role }}</div>
            </div>
        </div>
        <div v-else class="text-gray-500">
            {{ trans('general.not_available') }}
        </div>
    </div>
</template>
<script setup>
import { trans } from '@/mixins/i18n.js';

defineProps({
    title: String,
    contacts: Array,
});

const showPhone = (contact) => {
    if (!contact.phone) {
        return false;
    }

    if (!Array.isArray(contact.channelTypes)) {
        return true;
    }

    return contact.channelTypes.includes('voice') || contact.channelTypes.includes('sms');
};

const showEmail = (contact) => {
    if (!contact.email) {
        return false;
    }

    if (!Array.isArray(contact.channelTypes)) {
        return true;
    }

    return contact.channelTypes.includes('email');
};
</script>
